_ = require('underscore')
{ PowerUpItemType } = require 'common/components/power-up'
{ PowerUpLoadingSkeleton } = require 'common/components/power-up/loading-skeleton'
BaseDirectoryView = require './base-directory-view'
React = require 'react'
t = require 'recup'

class DirectoryLoading extends React.Component
  displayName: 'Directory Spinner'

  render: t.renderable ->
    t.div '.directory-content-body', =>
      t.div '.directory-listing', =>
        _.times @props.numOfAtoms, =>
          t.div '.directory-listing-powerup', =>
            t.tag PowerUpLoadingSkeleton, {
              type: @props.atomType
            }

class DirectorySpinner extends React.Component
  displayName: 'Directory Spinner'

  render: t.renderable ->
    t.div '.directory-listing', ->
      t.div '.directory-spinner', ->
        t.div '.spinner.loading.centered'

module.exports = class DirectorySpinnerView extends BaseDirectoryView
  renderContent: ->
    { section, idPlugin, isEnabling } = @options

    if _.contains(['category', 'custom', 'enabled'], section)
      return React.createElement DirectoryLoading, {
        numOfAtoms: 24,
        atomType: PowerUpItemType.Description
      }
    else if idPlugin || isEnabling
      return React.createElement DirectorySpinner
    else
      return React.createElement DirectoryLoading, {
        numOfAtoms: 6,
        atomType: PowerUpItemType.Featured
      }



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-spinner-view.coffee